import { useState } from 'react';
import { Search, X } from 'lucide-react';
import { formatCurrency } from '../../utils/format';
import { FipeBusca, type FipeResultado } from './FipeBusca';

interface FipeSelectorProps {
  marcaNome: string;
  modeloNome: string;
  anoModelo: number;
  value: number | null | undefined;
  onChange: (value: number | null, codigoFipe?: string) => void;
  label?: string;
  error?: string;
}

export function FipeSelector({
  marcaNome,
  modeloNome,
  anoModelo,
  value,
  onChange,
  label = 'Valor FIPE',
  error,
}: FipeSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleResultado = (resultado: FipeResultado) => {
    // Extrair valor numérico
    const valorStr = resultado.valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
    const valorNum = parseFloat(valorStr);
    if (!isNaN(valorNum)) {
      onChange(valorNum, resultado.codigoFipe);
    }
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}

      {/* Display Value */}
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className={`
            w-full px-3 py-2 border rounded-lg text-left flex items-center justify-between
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
            ${error ? 'border-red-500' : 'border-gray-300'}
            ${value ? 'bg-green-50 border-green-300' : 'bg-white'}
          `}
        >
          <span className={value ? 'text-green-700 font-medium' : 'text-gray-500'}>
            {value ? formatCurrency(value) : 'Clique para buscar valor FIPE'}
          </span>
          <Search className="w-4 h-4 text-gray-400" />
        </button>
      </div>

      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-4 max-h-[85vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b">
              <h3 className="font-semibold text-gray-900">Consulta Tabela FIPE</h3>
              <button
                type="button"
                onClick={handleCancel}
                className="p-1 text-gray-400 hover:text-gray-600 rounded"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-auto p-4">
              <FipeBusca
                marcaNome={marcaNome}
                modeloNome={modeloNome}
                anoModelo={anoModelo}
                onResultado={handleResultado}
                onCancel={handleCancel}
                modoInicial="filtros"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
